import React, { useState, useEffect } from 'react';
import Speedometer, { Background, Arc, Needle, Progress, Marks } from 'react-speedometer';
import '../css/Velocimetro.css';

const Velocimetro = ({ autoAccelerate }) => {
  const [value, setValue] = useState(0); // Valor inicial del velocímetro
  const [isAccelerating, setIsAccelerating] = useState(false); // Estado para saber si estamos acelerando

  const handleClick = () => {
    if (isAccelerating) return; // Evitar múltiples clics mientras se acelera

    setIsAccelerating(true); // Iniciar el proceso de aceleración
    let progress = value;
    const max = 180; // Máximo valor del velocímetro
    const increment = 1; // Incremento en cada ciclo
    let currentIncrement = increment; // Valor inicial de incremento

    const interval = setInterval(() => {
      if (progress >= max) {
        clearInterval(interval); // Limitar a 80 (máximo)
        setIsAccelerating(false); // Detener el proceso de aceleración
        window.location.href = autoAccelerate; // Ejecutar XXX() al terminar la animación
      } else {
        progress = Math.min(max, progress + currentIncrement); // Incremento controlado
        setValue(progress); // Actualizar el valor

        // Incrementar exponencialmente
        currentIncrement = currentIncrement * 1.05; // Aumento del incremento para simular aceleración exponencial
      }
    }, 20); // Intervalo más rápido para animación fluida
  };

  useEffect(() => {
    if (autoAccelerate) {
      handleClick(); // Llamar a handleClick si autoAccelerate es true
    }
  }, [autoAccelerate]); // Dependencia en autoAccelerate para activar una vez

  return (
    <Speedometer
      value={value}
      max={180}
      angle={160}
      fontFamily="squada-one"
      needleColor="#00FFFF"
      startColor="#00FFFF"
      endColor="#00FFFF"
      fluidWidth
      segments={8}
      segmentColors={['#00FFFF', '#00FFFF', '#00FFFF', '#00FFFF', '#00FFFF', '#00FFFF', '#00FFFF', '#00FFFF']}
    >
      <Background angle={180} />
      <Arc />
      <Needle />
      <Progress />
      <Marks />
    </Speedometer>
  );
};

// Definición de la función XXX()
const XXX = () => {
  console.log("Función XXX ejecutada.");
};

export default Velocimetro;
